<template>
  <editor>
    <el-breadcrumb slot="header">
      <el-breadcrumb-item>New</el-breadcrumb-item>
    </el-breadcrumb>
  </editor>
</template>
<script>
import Editor from './Editor'

export default {
  components: {
    Editor
  },
  created () {
    this.$store.dispatch('draftForm/setModel')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/news/Add.vue